import { type FC, useState } from 'react';
import { ChevronIcon } from '@/components/icons/menu/ChevronIcon';
import { cn } from '@/utils/cn';
import { isNavItemOrGroupActive, type NavItem } from '@/utils/navigation.utils';
import { MenuItem } from './MenuItem';

export const MenuItemGroup: FC<{
  menuItemGroup: NavItem & { subLinks: NavItem[] };
  pathname: string;
}> = ({ menuItemGroup, pathname }) => {
  const isActive = isNavItemOrGroupActive({
    currentPath: pathname,
    item: menuItemGroup,
  });
  const [isOpen, setIsOpen] = useState(isActive);

  const toggleIsOpen = () => setIsOpen((prev) => !prev);

  const isPickems = menuItemGroup.id === 'pickems';

  return (
    <div className={cn('rounded-lg', isOpen && 'bg-card-bg px-3 py-2')}>
      <button
        aria-expanded={isOpen}
        aria-label={`${menuItemGroup.name} submenu, ${
          isOpen ? 'expanded' : 'collapsed'
        }`}
        className={cn(
          'flex h-12 w-full items-center gap-3',
          isOpen ? 'mb-4' : 'px-3',
          isPickems && isActive && 'font-bold text-light-blue',
          isPickems && !isActive && 'text-light-blue'
        )}
        onClick={toggleIsOpen}
        type="button"
      >
        {menuItemGroup.icon && (
          <span className="shrink-0">{menuItemGroup.icon}</span>
        )}
        {menuItemGroup.name}
        <ChevronIcon
          aria-hidden="true"
          className={cn(
            'ml-auto h-6 w-6 transition-transform',
            isOpen ? 'rotate-180 transform' : ''
          )}
          desc="Chevron icon to toggle menu section"
          title="Toggle Menu"
        />
      </button>
      {isOpen && (
        <div className="space-y-1 pl-4">
          {/* TODO: improve NavItem typing to make `subLinks` required here */}
          {menuItemGroup.subLinks.map((sub) => {
            const subActive = isNavItemOrGroupActive({
              currentPath: pathname,
              item: sub,
            });
            return (
              <MenuItem
                currentPath={pathname}
                isActive={subActive}
                item={sub}
                key={sub.id}
                // isNarrow={true}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
